import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';
import { Button } from './Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    to: '/',
    label: 'HOME'
  }, {
    to: '/projects',
    label: 'PROJECTS'
  }, {
    to: '/about',
    label: 'ABOUT'
  }, {
    to: '/trips',
    label: 'TRIPS'
  }, {
    to: '/get-involved',
    label: 'GET INVOLVED'
  }, {
    to: '/news',
    label: 'NEWS'
  }, {
    to: '/donate',
    label: 'DONATE'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'}`} data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="flex justify-between items-center h-20" data-id="element-89">
          <Link to="/" className="flex flex-col items-start" data-id="element-90">
            <div className="flex items-center" data-id="element-91">
              <span className="text-2xl font-bold text-[var(--color-text)] tracking-tight" data-id="element-92">
                BIG L
              </span>
              <Heart size={20} className="text-[var(--color-primary)] fill-current mx-0.5" data-id="element-93" />
              <span className="text-2xl font-bold text-[var(--color-text)] tracking-tight" data-id="element-94">
                VE
              </span>
            </div>
            <div className="text-xs font-medium text-[var(--color-text-light)] tracking-widest -mt-1" data-id="element-95">
              FOUNDATION
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-96">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`text-sm font-medium tracking-wide transition-colors ${location.pathname === link.to ? 'text-[var(--color-primary)]' : 'text-[var(--color-text-light)] hover:text-[var(--color-text)]'}`} data-id="element-97">
                {link.label}
              </Link>)}
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 text-[var(--color-text)]" data-id="element-98">
            {isMobileMenuOpen ? <X size={24} data-id="element-99" /> : <Menu size={24} data-id="element-100" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-101">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-t border-gray-200" data-id="element-102">
            <div className="px-4 py-6 space-y-4" data-id="element-103">
              {navLinks.map(link => <Link key={link.to} to={link.to} onClick={() => setIsMobileMenuOpen(false)} className={`block text-base font-medium tracking-wide transition-colors ${location.pathname === link.to ? 'text-[var(--color-primary)]' : 'text-[var(--color-text-light)]'}`} data-id="element-104">
                  {link.label}
                </Link>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}